import { createContext, useState } from "react";
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import { saveAnswer } from "@educaplay/store/slices/gameSlice";
import { QUESTION_TYPE } from "../../utils/constants";
export const SliceContext = createContext()

export default function SliceProvider({ children, currentQuestion }) {
    const dispatch = useDispatch();
    const [showSlice, setShowSlice] = useState(false);
    const [hasViewed, setHasViewed] = useState(false);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [showSendButton, setShowSendButton] = useState(false);
    const currentQuestionTimeAppear = currentQuestion.timeAppearWithDuration ?? currentQuestion.timeAppear;

    const markQuestionViewed = () => {
        const userAnswer = {
            answer: currentQuestion.interactionTypeQuestion === QUESTION_TYPE.Info ? true : currentQuestion.answer?.answer ?? null,
            type: currentQuestion.interactionTypeQuestion,
        }
        dispatch(saveAnswer(userAnswer));

        setHasViewed(true);

    }

    return (
        <SliceContext.Provider value={{
            showSlice, setShowSlice, markQuestionViewed, hasViewed, setHasViewed, currentQuestionTimeAppear,
            openConfirmationDialog, setOpenConfirmationDialog, showSendButton, setShowSendButton, currentQuestion
        }}>
            {children}
        </SliceContext.Provider>
    )
}

SliceProvider.propTypes = {
    currentQuestion: PropTypes.object,
    children: PropTypes.node
}